module.exports = __webpack_public_path__ + "img/image5.93c15d97.svg";